(function (angular) {
  angular.module('xplenty-designer').factory('DesignerCloneComponent', [
    '$timeout',
    'DesignerComponent',

    function ($timeout, DesignerComponent) {
      function DesignerCloneComponent() {
        DesignerComponent.apply(this);
      }

      DesignerCloneComponent.prototype = new DesignerComponent();

      DesignerCloneComponent.prototype.getSchema = function () {
        const schema = DesignerComponent.prototype.getSchema.call(this);

        return schema;
      };

      return DesignerCloneComponent;
    },
  ]);
})(window.angular);
